import _classCallCheck from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Icon } from '../Icon';
import { BreadcrumbItem } from './BreadcrumbItem';
import styles from './Breadcrumb.scss';

var createBackLink = function createBackLink(backLinkText, backLinkUrl) {
  if (backLinkText && backLinkUrl) {
    return React.createElement("div", {
      className: styles.backLink
    }, React.createElement("a", {
      href: backLinkUrl
    }, React.createElement(Icon, {
      icon: "arrow-left-small",
      ariaHidden: true
    }), "Back to ", backLinkText));
  } else {
    return null;
  }
};

export var Breadcrumb = /*#__PURE__*/function (_React$Component) {
  _inherits(Breadcrumb, _React$Component);

  var _super = _createSuper(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          backLinkText = _this$props.backLinkText,
          backLinkUrl = _this$props.backLinkUrl,
          children = _this$props.children,
          className = _this$props.className,
          dataTest = _this$props.dataTest,
          _this$props$prefixLab = _this$props.prefixLabel,
          prefixLabel = _this$props$prefixLab === void 0 ? 'You are in:' : _this$props$prefixLab;
      var backLink = createBackLink(backLinkText, backLinkUrl);
      return React.createElement("nav", {
        className: "".concat(styles.breadcrumb, " ").concat(className),
        "data-test": dataTest,
        "aria-label": "Breadcrumbs"
      }, backLink, React.createElement("span", null, prefixLabel), React.createElement("ol", null, children));
    }
  }]);

  return Breadcrumb;
}(React.Component);
Breadcrumb.displayName = 'Breadcrumb';
Breadcrumb.Item = BreadcrumbItem;